// Application pages (ADR-0074): link the Bible references of the server-
// rendered text and example answer, exactly as the chat does. The HTML was
// rendered with raw HTML disabled, and linkBibleReferences touches text only.
import { linkBibleReferences } from './bible_links.js';
import { renderCheckedHtml, summaryElementHtml } from './answer_checks.js';

export function initializeContentPage(containers) {
    containers.forEach(container => {
        container.innerHTML = linkBibleReferences(container.innerHTML);
    });
}

// A shared conversation's answers (ADR-0084): linked as above and, while the
// display switch is on, marked from the check result the server wrote into
// `data-answer-checks` (ADR-0085 D-14). Without JavaScript the text stays
// readable and unmarked.
function checksOf(container) {
    const raw = container.getAttribute('data-answer-checks');
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (error) {
        return null;
    }
}

export function initializeSharedAnswers(containers) {
    containers.forEach(container => {
        const checks = checksOf(container);
        container.innerHTML = renderCheckedHtml(container.innerHTML, checks)
            + summaryElementHtml(checks);
    });
}
